import React from 'react'
// components
import PropertyDetailsDrawer from 'components/Modals/PropertyDetailsModal'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// types
import { IField } from 'types/graphql'
import { Modals } from 'constants/modals'
// utils
import { handleError } from 'utils/errors/handlers'
import { getValueFromOption } from 'utils/form'

const FieldDetailsDrawer: React.FC = () => {
  const { updateField, reorderFields, riskTemplate, basicFields } = React.useContext(RiskTemplateAPIContext)

  const { hideModal } = useShowModal({ modalType: Modals.PROPERTY_DETAILS_MODAL })

  const onFieldUpdate = async (data: Record<string, any>, field: IField, initialValues: Record<string, any>) => {
    try {
      const isParentChanged = data.parentFieldId && initialValues.parentFieldId?.value !== data.parentFieldId.value
      const isParentCleared = initialValues.parentFieldId?.value && !data.parentFieldId?.value
      const isPrevParentChanged =
        initialValues.parentFieldId && initialValues.parentFieldId.value !== data.parentFieldId?.value

      const position = isParentChanged
        ? basicFields.filter((f) => f.parentFieldId === data.parentFieldId.value).length + 1
        : isParentCleared
          ? basicFields.filter((f) => !f.parentFieldId).length + 1
          : field.position

      const preparedData = {
        ...data,
        position,
        parentFieldId: getValueFromOption(data.parentFieldId)
      }

      await updateField(preparedData, field)

      if (isPrevParentChanged) {
        const fieldsOrderInput = basicFields
          .filter((f) => f.parentFieldId === initialValues.parentFieldId.value && f.id !== field.id)
          .map((f, idx) => ({
            id: f.id,
            position: idx
          }))

        await reorderFields(fieldsOrderInput)
      }

      hideModal()
    } catch (e) {
      handleError(e, 'RiskTemplateBL.onFieldUpdate')
    }
  }

  return <PropertyDetailsDrawer updateField={onFieldUpdate} object={{ name: riskTemplate.name }} />
}

export default FieldDetailsDrawer
